<template>
  <resource-collection>
    <template slot-scope="{item}">
      <shop :shop="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Shop from './Shop.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Shop, ResourceCollection },

  mounted() {
    Event.listen('shopUpdated', shop => this.update(shop));
    Event.listen('shopCreated', shop => this.prepend(shop));
    Event.listen('shopDeleted', shop => this.remove(shop));
  },
};
</script>